const REJECTED_RE = /USER_REJECTED|User denied|User rejected|user rejected request|Confirmation declined|User cancelled|用户取消|用户拒绝|取消了授权|取消了交易/i

export function isWalletUserRejected(error) {
	if (!error) return false
	if (
		error.code === 4001 ||
		error.code === '4001' ||
		error.code === 'USER_REJECTED' ||
		error.code === 'USER_CANCELLED_CHAIN'
	) {
		return true
	}
	if (error.userRejected) return true
	if (error.i18nKey === 'wallet.userCancelledAuth') return true
	const nested = error.info && error.info.error
	if (nested && (nested.code == 4001 || nested.code === '4001')) return true
	return REJECTED_RE.test(String(error.message || error.toString() || ''))
}
